import React, { useRef, useEffect } from 'react'

export const loginInstructionCardData = {
  title: 'Login',
  content: [
    "You've requested to share your data with CompareBanks. Enter your Customer ID to continue.",
  ],
}

export const passwordInstructionCardData = {
  title: 'One Time Password',
  content: [
    <p>Enter the code sent to •••• ••• 190.</p>,
    <p>
      This code will expire in <b>09:54</b>.
    </p>,
  ],
}

export const selectInstructionCardData = {
  title: 'Select your accounts',
  content: [
    'CompareBanks is requesting your data. Please select the accounts you would like to share data from.',
  ],
}

export const confirmInstructionCardData = {
  title: 'Confirm what we’ll share',
  content: [
    'Please confirm that you agree to share the following data with CompareBanks.',
  ],
}
export const sharePeriodInformationCard = {
  title: 'Sharing period',
  content: ['1 June 2022 - 31 May 2023'],
  accordionHint: 'See more about sharing period',
  accordionContent: (
    <p>We will share your data on an ongoing basis for 12 months</p>
  ),
}
export const manageShareInformationCard = {
  title: 'Manage your data sharing',
  content: [
    "Go to 'Settings>Data sharing' to review this arrangement and stop sharing your data.",
  ],
  accordionHint: 'See more about data sharing',
  accordionContent: (
    <>
      <p>You can do this at any time in online banking or on the Bank 1 app.</p>
      <p>
        You can also tell us to stop sharing your data by writing to
        cdr@bank1.com.au.
      </p>
    </>
  ),
}

export const firstStepInstructionCardData = {
  title: 'Add your data to see offers and products tailored to you',
  content: [
    "First, you'll need to choose what you'd like to share so that your provider can sync your data.",
  ],
}

// DataHandlingInformationCard have customised func and foucs rule
export const DataHandlingInformationCard = (onClickFuc, setFocus) => {
  const dataDeletionBtn = useRef(null)
  useEffect(() => {
    if (dataDeletionBtn.current) {
      dataDeletionBtn.current.focus()
    }
  }, [setFocus])
  return {
    title: 'Data handling',
    content: [
      <p>
        The data that you share with CompareBanks is subject to{' '}
        <a
          href="javascript:;"
          target="_blank"
          rel="noreferrer"
          title="CDR protections information"
          aria-label="link to CDR protections information"
        >
          CDR protections (2 min read)
        </a>
      </p>,
    ],
    accordionHint: 'See more about data handling',
    accordionContent: (
      <>
        <p>
          CompareBanks will delete your data when we no longer need it to
          provide you with this service.{' '}
          <button onClick={() => onClickFuc()} ref={dataDeletionBtn}>
            Learn more about data deletion.
          </button>
        </p>
        <p>
          You can learn more about how we handle your data{' '}
          <a
            href="javascript:;"
            target="_blank"
            rel="noreferrer"
            title="CDR policy information"
            aria-label="link to CDR policy information"
          >
            in our CDR policy (5 min read)
          </a>
        </p>
        <p>
          If you think your data has been mishandled, you can make a complaint
          to{' '}
          <a
            href="mailto: complaints@comparebanks.com.au"
            aria-label="link to comparebanks complaints email"
          >
            complaints@comparebanks.com.au.
          </a>
        </p>
      </>
    ),
  }
}

export const ManageShareInformationCard = {
  title: 'Manage your data sharing',
  content: [
    <p>
      Go to 'Settings {'>'} Data sharing' at any time to review, manage and stop
      sharing your data.
    </p>,
  ],
  accordionHint: 'See more about data sharing',
  accordionContent: (
    <>
      <p>You can do this at any time on the CompareBanks website or app.</p>
      <p>
        You can also tell us to stop sharing your data by writing to{' '}
        <a
          href="mailto: datasharing@comparebanks.com.au"
          aria-label="link to comparebanks datasharing email"
        >
          datasharing@comparebanks.com.au.
        </a>
      </p>
      <p>
        We may not be able to provide you with tailored product comparisons when
        you stop sharing your data.
      </p>
    </>
  ),
}
